import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "sobre", label: "Sobre" },
  { id: "video", label: "Vídeo" },
  { id: "amenidades", label: "Amenidades" },
  { id: "tipologias", label: "Tipologias" },
  { id: "sustentabilidade", label: "Sustentabilidade" },
  { id: "localizacao", label: "Localização" },
  { id: "contacto", label: "Contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F9F9F6]/85 backdrop-blur-xl border-b border-[#E5E5DF]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 lg:h-24 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          aria-label="ANREÁL Residence"
          className="block relative h-14 lg:h-16 w-[176px] lg:w-[220px]"
        >
          <img
            src="/brand/anreal-white.svg"
            alt="ANREÁL"
            className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-500 ${scrolled ? "opacity-0" : "opacity-100"}`}
          />
          <img
            src="/brand/anreal-sage.svg"
            alt="ANREÁL"
            className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-500 ${scrolled ? "opacity-100" : "opacity-0"}`}
          />
        </a>
        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-[13px] text-[#1A1A1A]/70 hover:text-[#2B3B31] transition-colors tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-cta-desktop"
          onClick={() => scrollTo("contacto")}
          className="hidden lg:inline-flex items-center justify-center h-10 px-5 bg-[#2B3B31] text-[#F9F9F6] text-[12px] tracking-[0.22em] uppercase hover:-translate-y-[2px] transition-all duration-300"
        >
          Solicitar Info
        </button>
        <button
          data-testid="nav-toggle-mobile"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-[#1A1A1A] p-2"
          aria-label="Menu"
        >
          {open ? <X size={22} strokeWidth={1.25} /> : <Menu size={22} strokeWidth={1.25} />}
        </button>
      </div>
      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="lg:hidden bg-[#F9F9F6] border-t border-[#E5E5DF] px-6 py-6"
        >
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="text-left text-[15px] text-[#1A1A1A]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-cta-mobile"
              onClick={() => scrollTo("contacto")}
              className="mt-2 h-11 px-5 bg-[#2B3B31] text-[#F9F9F6] text-[12px] tracking-[0.22em] uppercase"
            >
              Solicitar Info
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
